import { variables } from '../variables';
import OnestBold from '../../fonts/GoldSilver/Onest-Bold.woff2';
import OnestMedium from '../../fonts/GoldSilver/Onest-Medium.woff2';
import OnestRegular from '../../fonts/GoldSilver/Onest-Regular.woff2';
import InstrumentSansBold from '../../fonts/GoldSilver/InstrumentSans-Bold.woff2';
import InstrumentSansRegular from '../../fonts/GoldSilver/InstrumentSans-Regular.woff2';
import InstrumentSansMedium from '../../fonts/GoldSilver/InstrumentSans-Medium.woff2';

export const goldSilverColors = {
  // Primary colors
  colorPrimary: '#1A4993', // GoldSilver Blue
  colorPrimaryLight: '#DCF2FD', // GoldSilver Tint
  colorPrimaryDark: '#051D37', // GoldSilver Shade
  colorBrandLight: '#fdb913', // GoldSilver Yellow
  colorProgressBarDefault: '#F4F4F4',
  colorWhite: '#ffffff',
  colorBlack: '#000000',
  colorRed: '#FF5028',
  colorGrey: '#f4f4f4',

  // Button colors
  colorButtonPrimary: '#1A4993',
  colorButtonPrimaryInactive: 'rgba(26, 73, 147, 0.5)',
  colorButtonPrimaryActive: 'rgba(26, 73, 147, 0.9)',
  colorButtonSecondary: '#F1F5F6', // don't use
  colorButtonSecondaryActive: '#E1E2E2F', // don't use

  // Icon
  colorCheckedIcon: 'green',
  colorSuccess: '#00876A',

  // Text
  colorTextPrimary: '#4E7A8C', // blue
  colorTextSecondary: '#003246', // semiDark
  colorTextOutline: '#14213D', // blueOutline
  colorTextLight: '#807F83', // light
  colorTextXLLight: '#595959', // XL light
  colorTextGrey: '#8E8E8E', // grey
  colorTextGrey5: '#394A64', // grey 5
  colorTextGrey6: '#293854', // grey6
  colorTextError: '#FF0000', // red
  colorLink: '#1A4993', // semiDark

  // Backgrounds
  colorBackgroundPrimary: '#ffffff', // white
  colorBackgroundPrimaryDark: '#F7F7F7', // whitish
  colorBackgroundSecondary: '#fafafa', // xlGrey
  colorBackgroundSecondaryLight: '#F1F5F6', // light grey
  colorBackgroundSecondaryDark: '#16191D', // dark
  colorBackgroundSecondaryDark1: '#ECECEC', // dark1
  colorBackgroundDropzone: '#f9f9f9', // grey2
  colorBackgroundModal: 'rgba(0, 0, 0, 0.55)',

  // Horizontal Break and Borders, Separators
  colorBorderPrimary: '#C9D6DB', // grey
  colorBorderPrimaryDark: '#d8d8d8', // grey2
  colorBorderSecondary: '#EEA527', // yellow
  colorBorderSemiDark: 'rgba(78, 122, 140, 0.3)',
  colorsDivider: '#EDF2F3', // outline

  // svg colors
  colorSvgSemidark: '#fdb913',

  // Input
  colorInputBackground: '#D89948',
  colorErrorMessage: '#FF5028',

  // Banner
  colorMisingInfoBackgorund: '#FFECB5',
  colorMissingInfoText: '#664D03',

  // Footer Colors
  colorFooterBackground: '#051D37',
  colorFooterText: '#dddddd',

  // Sidebar Gradients
  colorSidebarBegin: '#051D37',
  colorSidebarEnd: '#051D37',

  // Loader
  colorLoader: '#DCF2FD',
};

export const goldSilverFonts = `
  @font-face {
    font-family: ${variables.family.goldSilver};
    src: url(${InstrumentSansBold}) format('woff2');
    font-weight: bold;
    font-style: normal;
    font-display: fallback;
  }

  @font-face {
    font-family: ${variables.family.goldSilver};
    src: url(${InstrumentSansMedium}) format('woff2');
    font-weight: 600;
    font-style: normal;
    font-display: fallback;
  }

  @font-face {
    font-family: ${variables.family.goldSilver};
    src: url(${InstrumentSansMedium}) format('woff2');
    font-weight: 500;
    font-style: normal;
    font-display: fallback;
  }

  @font-face {
    font-family: ${variables.family.goldSilver};
    src: url(${InstrumentSansRegular}) format('woff2');
    font-weight: normal;
    font-style: normal;
    font-display: fallback;
  }

  @font-face {
    font-family: ${variables.family.goldSilverHeaders};
    src: url(${OnestBold}) format('woff2');
    font-weight: bold;
    font-style: normal;
    font-display: fallback;
  }

  @font-face {
    font-family: ${variables.family.goldSilverHeaders};
    src: url(${OnestMedium}) format('woff2');
    font-weight: 600;
    font-style: normal;
    font-display: fallback;
  }

  @font-face {
    font-family:  ${variables.family.goldSilverHeaders};
    src: url(${OnestRegular}) format('woff2');
    font-weight: normal;
    font-style: normal;
    font-display: fallback;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  h1 *,
  h2 *,
  h3 *,
  h4 *,
  h5 *,
  h6 * {
  font-family: ${variables.family.goldSilverHeaders};
  font-weight: bold;
}

  *,
  *::after,
  *::before {
    font-family: ${variables.family.goldSilver};
  }
`;
